<div class="a-select-input"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.has-select]="selectedItem">

  <div class="a-select-input__optional" *ngIf="isOptional">Optional</div>

  <div class="a-select-input__inner" 
    [class.is-focused]="inputFocused"
    [class.has-value]="control.value"
    [class.has-error]="control.invalid && isSubmitted">

    <div class="a-select-input__select" #selectEl
      *ngIf="selectedItem" 
      (click)="items && items.length && items.length > 1 && showDropdown()">
      <span *ngIf="selectedItem.img">{{ selectedItem.img }}</span>
      <span *ngIf="selectedItem.ico" [ngClass]="'app-ico app-ico__' + selectedItem.ico"></span>
      <i class="app-ico-mask app-ico-mask__select-arrow-down"
        *ngIf="items && items.length && items.length > 1"
        [class.is-open]="showItems">
      </i>
    </div>
    
    <div class="a-select-input__items-bg" *ngIf="items && items.length && showItems" (click)="showDropdown(false)"></div>
    <div class="a-select-input__items" @slideInOut
      *ngIf="items && items.length && showItems" 
      [class.open-top]="openPositionTop">
      <div class="a-select-input__search" *ngIf="searchActive">
        <input #searchEl
          type="text" 
          placeholder="Type to search" 
          [ngModel]="searchValue" 
          (ngModelChange)="findResult($event)">
        <i class="app-ico-mask app-ico-mask__x" *ngIf="searchValue" (click)="clearSearch()"></i>
      </div>
      <div class="a-select-input__items-inner is-scroll" #scrolledEl>
        <div class="a-select-input__item"
          *ngFor="let item of items; let i = index;" 
          [id]="'select-item-id-' + i"
          [class.active]="item.code ? item.code === selectedItem.code : item.value === selectedItem.value "
          (click)="selectItem(item); isInput.focus();">
          {{ item.img }} {{ item.label }}
        </div>
      </div>
    </div>

    <div class="a-select-input__input-box">
      <div class="a-select-input__input-box__selected" *ngIf="selectedItem && !hideSelectedItem">
        {{ selectedItem.value }}
      </div>
      <input #isInput
        placeholder=" "
        [formControl]="control"
        oninput="(type === 'tel' || type === 'number')
          ? event.target.value = event.target.value.replace(/[^0-9+]+/g, '')
          : event.target.value"
        onwheel="this.blur()"
        [class.has-selected-value]="selectedItem && !hideSelectedItem"
        [class.has-error]="control.invalid && isSubmitted"
        [type]="type"
        (focus)="onFocus(true)" 
        (blur)="onFocus(false)">
      <label>{{ label }}</label>
    </div>
  </div>

  <ng-container *ngIf="isAnonymous">
    <i class="app-ico-mask app-ico-mask__eye-off tooltip" @opacityInOut></i>
    <div class="tooltiptext">{{ 'Common.HiddenFromRecruiter' | translate }}</div>
  </ng-container>

  <div class="a-select-input__error-text" @opacityInOut
    *ngIf="control.invalid && isSubmitted && errorMessage">
    {{ errorMessage }}
  </div>
</div>